export default {
  "territory": {
    "title": "Territory Specificities",
    "description1": "In the Volcanic Region, the predominant vegetation consists of Atlantic Forest tropical forests. With volcanic soil, crop altitudes vary between 700 and 1,300 meters, with an average of 1,075 meters.",
    "description2": "The average annual temperature is between 17 and 20°C, and the average rainfall is 1,686 mm in the region, providing exceptional conditions for high-quality coffee cultivation.",
    "impact_title": "Coffee Growing Impact in the Region*",
    "producers": "Producers",
    "production_area": "Production Area",
    "population": "Population",
    "direct_jobs": "Direct Jobs",
    "annual_production": "Annual Production",
    "annual_production_unit": "(60kg bags/year)",
    "indirect_jobs": "Indirect Jobs",
    "unit": "million",
    "footnote": "*Sum of the 12 municipalities that make up the demarcated area"
  }
}
